import { Inject } from '@odinjs/odin';
import { PanelAPI } from '@philips-internal/oswald-ui-components';
import { Value } from '@philips-internal/oswald-ui-core';
import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import { cast } from '../../utils/cast-helpers';
import { showToastNotificationError } from '../../utils/toast-notification-utils';
import BaseController from '../BaseController';
import { AccountActivation } from 'src/interfaces/account-creation';
import { resolvePath } from '@philips-internal/oswald-ui-utils';

interface RouteParams {
  token: string;
}

@Controller({ component: 'layout-account-activation', fragment: 'account-activation' })
export default class AccountActivationController extends BaseController {

  @Inject('panel-loader')
    panelLoader!: PanelAPI;

  @Inject('panel-content')
    panelContent!: PanelAPI;

  @OnMount({target: 'layout-content'})
  async onMountLayoutAccountActivation(): Promise<void> {
    try {
      const body = { token: '' };
      const currentRoute = this.historyService.getCurrentRoute();

      if(currentRoute === APPLICATION_ROUTES.ACTIVATE) {
        const { token }: RouteParams = cast(this.historyService.getCurrentRouteQueryParams());
        body.token = token;
        token && (await HttpService.post(APPLICATION_ENDPOINTS.ACTIVATE_NEW_ACCOUNT, {}, { body }).then(response => {
          const accountActivation = response.body as AccountActivation;
          if (accountActivation?.accountCreatedByTasy) {
            accountActivation.routeOrigin = APPLICATION_ROUTES.ACTIVATE;
            accountActivation.token = body.token;
            this.usernameFlowValidation(accountActivation);
          }
        }));
      } else {
        const reactiveRoute = APPLICATION_ROUTES.REACTIVATE.replace(':token', '');
        if(currentRoute.includes(reactiveRoute)) {
          const token = this.getHistoryRouteParam<Value>('token');
          body.token = token ? String(token) : '';
          token && (await HttpService.post(APPLICATION_ENDPOINTS.REACTIVATE_ACCOUNT, {}, { body }));
        }
      }

      if(!body.token) {
        this.historyService.push(APPLICATION_ROUTES.LOGIN);
        return;
      }

      this.panelLoader.setVisible(false);
      this.panelContent.setVisible(true);
    } catch(error) {
      const {body} = error as Record<string, Value>;
      if(body) {
        this.historyService.push(APPLICATION_ROUTES.LOGIN);
        showToastNotificationError(body as string);
      } else {
        this.historyService.push(APPLICATION_ROUTES.LOGIN);
        showToastNotificationError('newaccount.error.internal.server.error.try.again');
      }
    }
  }

  usernameFlowValidation(accountActivation: AccountActivation): void {
    if (accountActivation.accountCreatedByTasy && accountActivation.userSuggestionCreatedInTasy) {
      const srcPath = resolvePath(`${APPLICATION_ROUTES.RESET_PASSWORD}?token=:token&user=:user`, {
        token: accountActivation.token,
        user: accountActivation.userSuggestionCreatedInTasy
      })
      this.historyService.push(srcPath);
    }
  }

  @OnClick({ target: 'button-go-login' })
  onClickButtonGoLogin(): void {
    this.historyService.push(APPLICATION_ROUTES.LOGIN);
  }

}
